import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'ar';
    document.documentElement.dir = 'rtl';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mlaxj7fckftz">
      <div lang="ar" dir="rtl" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mk83wrqn3zad">
        <CountdownBar data-id="element-2" data-mp="3rcsy3udgkeef" />
        <main data-id="element-3" data-mp="3reccfffk0fdk">
          <Hero data-id="element-4" data-mp="5yj0slx59ec" />
          <StatsBar data-id="element-5" data-mp="6hrlipoilfp" />
          <Difference data-id="element-6" data-mp="4wx1t3d72hu" />
          <Recognize data-id="element-7" data-mp="56nfhsbnbo2" />
          <WhatsInside data-id="element-8" data-mp="7ssnarqpf34" />
          <InsidePages data-id="element-9" data-mp="2zllf11m4wkmq" />
          <Bonuses data-id="element-10" data-mp="2zm4xcjfp5b1a" />
          <HowItWorks data-id="element-11" data-mp="2zmo7vf30ox5a" />
          <Audience data-id="element-12" data-mp="2zng0ch1bierc" />
          <Offer data-id="element-13" data-mp="33mf0loc3tncg" />
          <Guarantee data-id="element-14" data-mp="33lx02fiesmyq" />
          <Testimonials data-id="element-15" data-mp="33n6zp94wu37h" />
          <Faq data-id="element-16" data-mp="33ork45xig5rm" />
          <FinalCta data-id="element-17" data-mp="38lrqkhy9vaj9" />
        </main>
        <Footer data-id="element-18" data-mp="38kqc03i1s5ws" />
      </div>
    </MotionConfig>;
}